// extracted by mini-css-extract-plugin
module.exports = {"SidebarItem":"SidebarItem_SidebarItem__3Waq6","Active":"SidebarItem_Active__1BtrK"};